import React, { Component } from "react";
import CartContext from "./CartContext";
import { Link } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import {
  KioskModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  PackagingManagementModule,
  DeliveryManagementModule,
  CrmModule,
  CouponsManagementModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  QrcodeModule,
  DemoButton,
} from "./CommonModules";

const BenefitsList = ({ benefits }) => (
  <ul
    className="text-muted"
    style={{ lineHeight: "1.5em", marginBottom: "15px" }}
  >
    {benefits.map((benefit, index) => (
      <li key={index}>{benefit}</li>
    ))}
  </ul>
);

const FeaturesList = ({ features }) => (
  <ul
    className="text-muted"
    style={{ lineHeight: "1.5em", marginBottom: "15px" }}
  >
    {features.map((feature, index) => (
      <li key={index}>✔ {feature}</li>
    ))}
  </ul>
);

const ERPModulesSection = () => (
  <section className="container my-5">
    <h1 className="text-dark mb-4">
      Explore Integrated ERP Modules That Power Your Business
    </h1>
    <Row className="g-3">
      {[
        QrcodeModule,
        InventoryModule,
        PurchasesModule,
        OrdersManagementModule,
        PackagingManagementModule,
        DeliveryManagementModule,
        CrmModule,
        CouponsManagementModule,
        HrmModule,
        AccountingModule,
        ReportsModule,
      ].map((Module, index) => (
        <Col md={6} lg={6} key={index}>
          <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
            <Module />
          </div>
        </Col>
      ))}
    </Row>
  </section>
);

export class QRCodePos extends Component {
  static contextType = CartContext;

  handleButtonClick = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    }
    SetSelectedProduct(
      prods.find((f) => f.productType === ProductType.QRCODE_ECommerce)
    );
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        <div className="container-fluid py-3">
          <div className="container">
            <div className="row gx-5">
              <div className="border-start border-5 border-primary ps-3 mb-3">
                <h6 className="text-primary text-uppercase">
                  Product & Features
                </h6>
                <h2 className="display-6 mb-0">
                  <b>Self Ordering solution via QRCODE</b>
                </h2>
              </div>
              <span className="text-muted" style={{ textAlign: "justify" }}>
                We offer Self ordering solution via QRCODE for various business
                Use cases. Customers can scan your Business QRCODE to see the
                Menu of your Products on their own Phone/Tablet for self
                Ordering. In a Retail shop, Customers can scan the QRCODE to
                view product catalog, Price, availablity and evan to order for
                Delivery. On a Restaurant, Customer can order food from
                Table/Lobby by scanning QRCODE.
              </span>

              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "QrCodeVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              <br />
              <div className="col-lg-6 border-dark my-2">
                <img
                  className="w-100 h-100 rounded border"
                  src="img/qrcode.png"
                  style={{ objectFit: "contain" }}
                />
              </div>
              <div className="col-lg-6">
                {
                  <Button
                    as={Link}
                    variant="warning"
                    className="w-100 mb-3"
                    to="/Checkout"
                    onClick={(e) => this.handleButtonClick}
                  >
                    Try Free / Buy
                  </Button>
                }
                <h4>Benefits</h4>
                <BenefitsList
                  benefits={[
                    "Ordering from anywhere",
                    "Order from Table/Lobby in Restaurant",
                    "View product Catalog, Price and availablity in a Retail Store",
                    "Reduce Labor Cost",
                    "Delight Customer and Envy Competitors",
                    "Improved Customer Satisfaction",
                    "Reduce POS Queue time",
                    "Increase Turnover",
                  ]}
                />
                {
                  <>
                    <h4>Features</h4>
                    <FeaturesList
                      features={[
                        "Free SSL and Custom domain",
                        "Premium & Custom Themes",
                        "OTP Authentication (SMS)",
                        "UPI Integration",
                        "Product Variants, Multi-Image, Video",
                        "Paper/Paperless Invoice",
                        "Multi-Store, Multi-Vendor, Multi-Currency",
                        "Product Reviews, Ratings, and Comments",
                        "Analytics, Reports, Customer Dashboard",
                      ]}
                    />
                  </>
                }
              </div>
            </div>
          </div>
        </div>
        <DemoButton></DemoButton>
        <ERPModulesSection />
        <DemoButton></DemoButton>>
      </>
    );
  }
}
